module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-titlej"
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Especial thanks go to Elizabeth Holland, who shared her memories of her father Jo Holland, the founder of MI(R), and revealed the family connections to other MI(R) officers. Thanks are also owed to Darron Wadey for discussion on the operations of MI(R) in the Netherlands and to Gerard Murphy for providing sources relating to Jo Holland’s service in Ireland. As with previous publications, the assistance of Lee Richards of ARCRE in copying documents in The National Archives has been invaluable and we thank the staff of The National Archives and Imperial War Museum for their kind attention. I am particularly grateful to David Gordon and David Sampson for making photographs of their remarkable collections available for reproduction. Thanks also to Kate Atkin for additional photography. The cooperation of the copyright holders is acknowledged in the individual captions. As ever, thanks to my wife Susanne for her support and patience, correcting my grammar and for compiling the Index. Rupert Harding and Sarah Cook of Pen & Sword steered the completed text through the publication process with their customary skill and patience.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30bd1f37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Acknowledgements.vue
// module id = 78
// module chunks = 0